var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 52,
    viewBox: "0 0 59 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.29883 21.4314C5.39363 21.4314 7.53607 20.1444 9.33372 19.2369C15.901 15.9213 22.0387 12.1341 29.1148 9.91021C36.2486 7.66815 43.4753 4.42626 50.755 2.80854C52.7803 2.35849 52.6752 3.60229 52.6752 5.33832C52.6752 11.0131 52.927 16.4837 53.8944 22.1019C55.425 30.9914 56.5156 39.8362 56.5156 48.8627",
    stroke: "#FAFBFD",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.793 34.5986C30.1728 35.0853 34.6532 38.6946 38.8686 40.0544C42.7659 41.3116 45.7451 43.3427 49.0182 45.7845C51.3776 47.5447 53.6622 49.5174 52.6757 45.5712",
    stroke: "#FAFBFD",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.20312 24.1748C5.35833 24.1748 7.14499 28.238 9.45719 30.0878C10.3867 30.8314 13.6275 28.8482 14.3948 28.5029C20.9119 25.5702 27.0483 22.3132 33.3834 19.0238C35.7324 17.8042 38.2023 16.7283 40.1803 14.9701C41.779 13.549 37.1895 18.0561 35.9741 19.8163C32.534 24.7986 31.7361 32.1764 25.7941 35.1474",
    stroke: "#FAFBFD",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.23828 34.598C8.36001 36.6675 10.0357 49.35 12.353 49.35C14.3668 49.35 16.6771 43.7611 17.6564 42.5226C20.3986 39.0545 24.3014 36.4058 26.8916 32.9521",
    stroke: "#FAFBFD",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegram-icon.cd4fe8e59a8defe49c116d799d332d4e.svg";
export { ForwardRef as ReactComponent };